import controller from './home.controller';
import template from './home.pug';

const HomeComponent = {
  template,
  controller,
};

export default HomeComponent;



// WEBPACK FOOTER //
// ./client/app/home/home.component.js